const _excluded = ["user", "claimGroup"],
  _excluded2 = ["user", "claim"],
  _excluded3 = ["user", "claimGroup"],
  _excluded4 = ["user", "claimGroup"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { ChangeSet } from '@rd-web-markets/shared/dist/models/ChangeSet';
import { hasClaimGroupUserAccessWithRoles, hasClaimGroupUserAccessWithSetting, isUserAdmin, isUserClaimGroupManager } from '@rd-web-markets/shared/dist/util/user/userUtils';
import { createPagesAbilitiesProxy } from '@rd-web-markets/shared/dist/util/userAbilities';
import { useEffect, useState } from 'react';
export { useGetUserCompanyAbilities } from '@rd-web-markets/shared/dist/util/userAbilities';
function getConsultantClaimGroupAbilities(user) {
  // true for anything not specified here
  const abilities = {
    pages: {
      ClaimGroupOverviewPage: {
        components: {
          engagementTeam: {
            canEditAnyTypeOfUser: true,
            canAddAccountants: false,
            canCreateNewCustomerUsers: false
          }
        }
      }
    }
  };
  const proxy = createPagesAbilitiesProxy(abilities);
  return proxy;
}
function getUserClaimGroupAbilities(_ref) {
  var _additionalData$revie;
  let {
      user,
      claimGroup
    } = _ref,
    additionalData = _objectWithoutProperties(_ref, _excluded);
  if (!['customer', 'consultant'].includes(user.account_type)) {
    return createPagesAbilitiesProxy({
      pages: {}
    });
  }
  if (user.account_type === 'consultant') {
    return getConsultantClaimGroupAbilities(user);
  }

  // by default using useParams will return string, so just in case
  const claimGroupId = parseInt(claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.id);
  if (!user || !claimGroupId) {
    return createPagesAbilitiesProxy({
      pages: {}
    });
  }
  const userClaimGroupAccess = user.user_accesses.find(user_access => user_access.rollable_id === claimGroupId && user_access.rollable_type === 'ClaimGroup') || {};
  const userIsEngagementTeamMember = userClaimGroupAccess.included_in_engagement_team;
  const userClaimGroupRoles = userClaimGroupAccess.roles || [];
  const rolesWithProjectOverviewAccess = ['technical_contact', 'financial_contact', 'project_manager'];
  const userRoleHasProjectDetailsAccess = !!rolesWithProjectOverviewAccess.filter(roleWithAccess => userClaimGroupRoles.some(userRole => roleWithAccess === userRole)).length;
  const userHasAnyClaimGroupRole = roles => roles.some(role => userClaimGroupRoles.includes(role));
  const canAccessProjectDetails = userRoleHasProjectDetailsAccess || userIsEngagementTeamMember;
  const userIsAdminOrClaimGroupManager = isUserAdmin(user) || isUserClaimGroupManager(user, claimGroup);
  const objectIsUnderClientReview = new ChangeSet({
    changeSet: (additionalData === null || additionalData === void 0 || (_additionalData$revie = additionalData.reviewedObject) === null || _additionalData$revie === void 0 ? void 0 : _additionalData$revie.active_change_set) || {}
  }).isUnderClientReview();
  const canCompleteTrackChangesReview = userIsAdminOrClaimGroupManager || objectIsUnderClientReview;
  const canAccessViewReport = userClaimGroupAccess.access_to_signed_off_rnd_report && objectIsUnderClientReview;
  const canAccessFinancialDocuments = user.account_type !== 'customer' || userHasAnyClaimGroupRole(['client_sponsor', 'financial_contact', 'accountant']);
  const canAccessTechnicalDocuments = user.account_type !== 'customer' || userHasAnyClaimGroupRole(['client_sponsor', 'technical_contact', 'accountant']);
  const canViewClaimGroupCostDataSidebarMenu = user.account_type !== 'customer' || hasClaimGroupUserAccessWithRoles(user, claimGroup, ['financial_contact', 'client_sponsor']);
  const canSeeAddClaimSidebarButton = user.account_type !== 'customer';
  const canSeeDocumentsSidebarButton = user.account_type !== 'customer' || hasClaimGroupUserAccessWithSetting(user, claimGroup, 'has_claim_group_document_access');
  const canCreateNewProjects = user.account_type !== 'customer' || hasClaimGroupUserAccessWithSetting(user, claimGroup, 'can_create_new_projects');
  const canDownloadProjectData = user.account_type !== 'customer' || hasClaimGroupUserAccessWithSetting(user, claimGroup, 'has_data_centre_project_data_access');
  const canDownloadCostData = user.account_type !== 'customer' || hasClaimGroupUserAccessWithSetting(user, claimGroup, 'has_data_centre_cost_data_access');
  const canViewDataCentreSidebarMenu = canDownloadProjectData || canDownloadCostData;
  const abilities = {
    pages: {
      ProjectOverviewPage: {
        canAccessPage: true,
        canAccessProjectDetailsLink: canAccessProjectDetails
      },
      ClaimProjectReportDetailPage: {
        canAccessPage: canAccessProjectDetails,
        canEditProjectDetails: false,
        canEditProjectActivity: true,
        // this tab is called Project Notes (from translations) now
        canAccessProjectReportTab: canAccessProjectDetails,
        canAccessDocumentsTab: canAccessProjectDetails,
        canAccessNotesTab: canAccessProjectDetails,
        canDeleteProjectNotes: false,
        // except if own notes
        canAccessCompetentProfessionalsTab: userIsEngagementTeamMember,
        canAccessSummarySubtab: userIsEngagementTeamMember,
        canAccessTechnicalNarrativeSubtab: userIsEngagementTeamMember,
        canAccessAiDrafterSubTab: false,
        // clients cannot access this
        canAccessContactsSubTab: canAccessProjectDetails,
        canEditExistingDocumentsOrFolders: false,
        canEditContacts: false
      },
      ClaimGroupOverviewPage: {
        components: {
          engagementTeam: {
            canEditAnyTypeOfUser: false,
            canAddAccountants: userIsAdminOrClaimGroupManager,
            canCreateNewCustomerUsers: userIsAdminOrClaimGroupManager
          }
        }
      },
      ProjectReportQuestionnairesPage: {
        canEditQuestionnaire: !userIsEngagementTeamMember
      },
      ProjectRndReportsPage: {
        components: {
          ReportPreviewControls: {
            canEditDynamicFields: false
          }
        }
      },
      MyClaimGroupsPage: {
        components: {
          ClaimGroupList: {
            canAccessViewReport: canAccessViewReport
          }
        }
      },
      any: {
        canClickCompleteTrackChangesReview: canCompleteTrackChangesReview,
        canViewClaimGroupCostDataSidebarMenu,
        canSeeAddClaimSidebarButton,
        canSeeDocumentsSidebarButton,
        canViewDataCentreSidebarMenu,
        canDownloadProjectData,
        canDownloadCostData,
        canCreateNewProjects,
        canAccessFinancialDocuments,
        canAccessTechnicalDocuments,
        something: false
      }
    }
  };
  const proxy = createPagesAbilitiesProxy(abilities);
  return proxy;
}
export function getUserClaimAbilities(_ref2) {
  let {
      user,
      claim
    } = _ref2,
    params = _objectWithoutProperties(_ref2, _excluded2);
  const canDirectlyEditTotalCosts = user.account_type === 'admin';
  const abilities = {
    pages: {
      TotalCosts: {
        canDirectlyEditTotalCosts
      }
    }
  };
  const proxy = createPagesAbilitiesProxy(abilities);
  return proxy;
}
export function useGetUserClaimAbilities(_ref3) {
  let {
      user,
      claimGroup
    } = _ref3,
    additionalData = _objectWithoutProperties(_ref3, _excluded3);
  // it always initially returns this state, so we need to build it asap
  return getUserClaimAbilities(_objectSpread({
    user,
    claimGroup
  }, additionalData));
}
export function useGetUserClaimGroupAbilities(_ref4) {
  let {
      user,
      claimGroup
    } = _ref4,
    additionalData = _objectWithoutProperties(_ref4, _excluded4);
  // it always initially returns this state, so we need to build it asap
  return getUserClaimGroupAbilities(_objectSpread({
    user,
    claimGroup
  }, additionalData));
}